import { AppLayoutBreakpoint } from '../../../util/responsiveness';

import { useAppLayoutContext } from './useAppLayoutContext';
import { useContentContainerContext } from './useContentContainerContext';

type UseShouldRenderSidebarAtCurrentWidth = () => boolean;
export const useShouldRenderContentSidebarAtCurrentWidth: UseShouldRenderSidebarAtCurrentWidth = () => {
  const { contentContainerWidth } = useContentContainerContext();
  const breakpoint = useAppLayoutContext()?.pinnedCollapsibleRightRail
    ? AppLayoutBreakpoint.Width892
    : AppLayoutBreakpoint.Width812;

  return shouldRenderContentSidebarAtWidth(contentContainerWidth, breakpoint);
};

export const shouldRenderContentSidebarAtWidth = (width: number, breakpoint: number): boolean => width >= breakpoint;
